// Import necessary modules and components
import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// import NoPage from './pages/NoPage';
import jsonServerProvider from 'ra-data-json-server';



import AdminApp from './AdminApp/AdminApp';
import ClientApp from './ClientApp/ClientApp';
import Prompts from './ClientApp/pages/Prompts';


// App component
function App() {
  return (
    <Router>
      <Routes>
        {/* <Route path="/" element={<Home />} /> */}
        <Route index element={<ClientApp />} />
        <Route path='/prompts' element={<Prompts />} />
        <Route path="/admin/*" element={<AdminApp />} />
        {/* <Route path="*" element={<NoPage />} /> */}
      </Routes>
    </Router>

  );
}

// Export the App component as the default export
export default App;
